import { render } from "./EcommerceDeleteProcessor.vue?vue&type=template&id=2ddd23c1"
import script from "./EcommerceDeleteProcessor.vue?vue&type=script&lang=js"
export * from "./EcommerceDeleteProcessor.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__